/* app/ui/logIn/logIn */

define(
	'app/ui/logIn/login',[
		'jquery'
	],

	function ($) {

		'use strict';

		var selectors = {
			trigger: '.js-login-remember-trigger',
			target: '.js-login-remember-target'
		};
		var $trigger;
		var $target;

		var module = {
			init: function() {

				module._initElements();
				module._initEvents();
			},

			_initElements: function() {
				$trigger = $(selectors.trigger);
				$target = $(selectors.target);
			},

			_initEvents: function() {
				$trigger.on('change', module._updateTargetValue);
			},

			_updateTargetValue: function() {
				var remember = false;
				var rememberActive = '&remember=true';

				if ($trigger.is(':checked')) {
					remember = true;
				}

				if ($target.val().indexOf(rememberActive)) {
					$target.val($target.val().replace(rememberActive, ''));
				}

				if (remember) {
					$target.val($target.val() + rememberActive);
				}

				//console.log({
				//	url: $target.val(),
				//	checked: $trigger.is(':checked')
				//});
			}
		};

		return {
			init: module.init
		};

	}
);

